//#region src/locales/en/tamagotchi/settings.yaml
var data = {
	"allow-visible-on-all-workspaces": {
		"title": "Cross-Space Visibility",
		"description": "Allow the window to be visible on all workspaces, macOS only."
	},
	"microphone-permission": {
		"prompt": {
			"title": "Allow microphone access?",
			"description": "AIRI uses your microphone for voice input and transcription. This choice remains active until you reset it in Settings.",
			"allow": "Allow",
			"deny": "Deny"
		},
		"states": {
			"not-determined": "Not set",
			"granted": "Allowed",
			"denied": "Denied"
		},
		"settings": {
			"title": "Microphone",
			"description": "Control whether AIRI can use the microphone. Resetting this choice stops the current microphone stream and asks again next time.",
			"revoke": "Revoke access",
			"reset": "Reset decision"
		}
	},
	"spotlight": { "errors": {
		"unknown": "Unknown error",
		"prefix": "Something went wrong: {message}",
		"shortcutRegistrationFailed": "Something went wrong: failed to register Spotlight shortcut."
	} },
	"pages": {
		"modules": { "mcp-server": {
			"description": "Connect and manage MCP server and tools",
			"title": "MCP Server"
		} },
		"system": {
			"general": { "hide-app-icon": {
				"title": "Hide taskbar / Dock icon",
				"description": "Keep AIRI in the tray only. Use the tray menu to open windows or quit. Changes apply immediately.",
				"load-error": "Failed to load the app icon setting.",
				"save-error": "Failed to update the app icon setting."
			} },
			"sections": { "section": { "window-shortcuts": { "title": "Keyboard Shortcuts" } } },
			"window-shortcuts": {
				"description": "Modify the window shortcuts.",
				"title": "Window Shortcuts",
				"empty": "Not set",
				"spotlight": {
					"title": "Spotlight shortcut",
					"description": "Click the shortcut, then press a new shortcut. Press Esc to cancel."
				},
				"actions": {
					"recording": "Press keys",
					"reset": "Reset"
				},
				"errors": {
					"load": "Failed to load shortcut",
					"conflict": "Shortcut already in use.",
					"failed": "Failed to update shortcut",
					"requiresModifier": "Use at least one of Cmd, Ctrl, Alt, or Super."
				},
				"toggle-move": { "label": "Toggle Move" },
				"toggle-resize": { "label": "Toggle Resize" },
				"toggle-ignore-mouse-event": { "label": "Toggle Ignore Mouse Event" },
				"press-keys": "Press Keys..."
			},
			"developer": { "sections": { "section": { "use-window-mouse": {
				"title": "useWindowMouse Tool",
				"description": "Test the Electron window cursor position"
			} } } }
		}
	},
	"devtools": {
		"title": "Developer",
		"pages": {
			"context-flow": { "title": "Context Flow" },
			"presence-bubble": {
				"title": "Presence Bubble",
				"description": "Drive the bubble above the character and watch it in the main window",
				"override": {
					"title": "Drive the bubble from here",
					"description": "While this is off the stage shows no bubble unless a chat turn is running."
				},
				"thinking": {
					"title": "Thinking",
					"description": "Shows the dots. Takes precedence over the unread count."
				},
				"unread": {
					"title": "Unread messages",
					"description": "Shown as a panel on the head, with a mark and the count."
				},
				"main-window-note": "Changes appear in the main AIRI window."
			},
			"live2d-ambient-light": {
				"title": "Live2D Ambient Light",
				"description": "Tune screen sampling and the Live2D color-light shader",
				"controls": { "title": "Light source and output" },
				"enabled": {
					"title": "Ambient light",
					"description": "Apply the ambient-light filter to the active Live2D model."
				},
				"source": {
					"title": "Light source",
					"options": {
						"screen-capture": "Screen capture",
						"forced-color": "Forced color"
					}
				},
				"mode": {
					"title": "Lighting mode",
					"options": {
						"window-gradient": "Window gradient",
						"global": "Global ambient"
					}
				},
				"forced-color": {
					"title": "Test color",
					"description": "Apply this color without screen capture."
				},
				"strength": {
					"title": "Light strength",
					"description": "Set the overall effect amount. 1 is the designed look, and up to 3 makes the light wrap and the backlight stronger."
				},
				"squint": {
					"title": "Squint at bright changes",
					"description": "Narrow the eyes when the screen brightens faster than the character has adapted to it. A screen that stays bright leaves the eyes open. 0 turns this off."
				},
				"main-window-note": "Changes appear in the main AIRI window.",
				"diagnostics": {
					"title": "Capture diagnostics",
					"waiting": "Waiting for diagnostics from the main AIRI window.",
					"status": {
						"disabled": "Disabled",
						"starting": "Starting",
						"capturing": "Capturing",
						"forced-color": "Forced color",
						"error": "Error"
					},
					"capture": {
						"title": "Capture state",
						"description": "Inspect the selected display, capture dimensions, and exclusion coordinates.",
						"display": "Display and bounds",
						"video-size": "Source video",
						"sample-size": "Sample frame",
						"window-bounds": "AIRI window bounds",
						"excluded-region": "Excluded region",
						"exposure": "Screen exposure",
						"behind-luminance": "Light behind the character",
						"updated": "Last update"
					},
					"preview": {
						"title": "Downscaled capture",
						"description": "The red rectangle marks the AIRI window. The dashed rectangle marks the area that the light maps cover.",
						"unavailable": "No captured frame is available."
					},
					"pixels": {
						"title": "Pixel decisions",
						"total": "Total",
						"accepted": "Accepted",
						"excluded": "Painted",
						"transparent": "Transparent",
						"see-through": "See-through"
					},
					"maps": {
						"title": "Light maps",
						"window": "Each map covers the AIRI window and half a window on every side. The outline marks the window.",
						"unavailable": "No environment is available.",
						"target": "Measured",
						"applied": "Applied after smoothing",
						"surround": {
							"title": "Surround map",
							"description": "Wide blur of the screen around and behind the window. It carries the color of the light and the side it comes from."
						},
						"contact": {
							"title": "Contact map",
							"description": "Narrow blur of the same content. This map drives the light wrap and the backlight rim."
						}
					}
				},
				"sampling": {
					"title": "Screen sampling",
					"capture-interval": {
						"title": "Capture interval",
						"description": "Set the time between screen samples. The capture stream runs at this rate."
					},
					"response-time": {
						"title": "Response time",
						"description": "Set how quickly sampled colors adapt to a screen change."
					},
					"sample-width": {
						"title": "Sample size",
						"description": "Set the width of the downscaled capture frame. A wider frame puts more detail in the light maps. The height follows your display."
					},
					"neutral-color-weight": {
						"title": "Neutral-color weight",
						"description": "Set the minimum weight for colors with low saturation. Colored content counts for more than gray."
					}
				},
				"shader": {
					"title": "Shader response",
					"dark-base": {
						"title": "Brightness floor",
						"description": "Set the model brightness over a black screen. A white screen shows the model as drawn, and a darker screen dims it toward this floor."
					},
					"base-curve": {
						"title": "Brightness curve",
						"description": "Set how the model brightness rises between the floor and the artwork. Above 1 a half-lit screen keeps the model closer to the floor."
					},
					"local-share": {
						"title": "Local light share",
						"description": "Set how much of the model brightness follows the light beside it rather than the whole display. At 0 the model keeps one brightness wherever its window sits."
					},
					"tint": {
						"title": "Tint",
						"description": "Set how much of the screen hue the model takes. At 0 only the screen brightness reaches the model."
					},
					"color-boost": {
						"title": "Dim-light color boost",
						"description": "Set how much extra color the model takes from dim but saturated light. Brightness stays where the light put it, and no channel falls below the unlit model."
					},
					"wrap-intensity": {
						"title": "Light wrap intensity",
						"description": "Set how strongly the background color bleeds onto the edge of the model."
					},
					"wrap-saturation": {
						"title": "Light wrap saturation",
						"description": "Set how much of the screen hue the wrapped light keeps. 0 adds white light of the same brightness. 1 adds the full screen color."
					},
					"backlight": {
						"title": "Backlight",
						"description": "Set how strongly light from behind the character lights the thin rim along its whole edge."
					},
					"wrap-diffuse": {
						"title": "Light wrap width",
						"description": "Set how far the wrapped background color reaches inside the edge of the model."
					},
					"translucent-wrap": {
						"title": "Reduce wrap on translucent parts",
						"description": "Scale the light wrap and rim by the square of the model alpha. Parts drawn with partial alpha already show the desktop through themselves."
					}
				},
				"preview-shader": {
					"title": "Shader preview",
					"description": "Run the real shader over a test card, with the live environment and the settings above.",
					"window-mapping": "The filter takes this canvas as the whole stage window, so the preview is not a pixel-accurate copy of the stage.",
					"filtered": "Shader output",
					"unavailable": "The preview needs WebGL, and this window could not create a context.",
					"environment": {
						"live": "Light comes from the latest snapshot that the main AIRI window published.",
						"neutral": "No snapshot has arrived yet, so the preview uses the neutral environment."
					},
					"regions": {
						"title": "Test card regions",
						"body": "The wide body carries a tone ramp from sRGB {low} to {high}. Brightness, contrast, chroma, and headroom show along it.",
						"bars": "The bars are {first}, {second}, {third}, {fourth}, and {fifth} pixels wide. They show how far the light wrap reaches into a thin shape.",
						"patches": "The two patches are drawn at {strong} and {weak} alpha, which is what the translucent-wrap option acts on."
					}
				}
			},
			"editor": {
				"title": "AIRI Editor",
				"description": "Open the standalone AIRI Editor window",
				"button": "Open Editor"
			},
			"lag-visualizer": { "title": "Lag Visualizer" },
			"live2d-motion": {
				"title": "Live2D Motion Control",
				"description": "Control Live2D eye, head, and body motion.",
				"actions": { "back": "Back" },
				"system-audio": {
					"title": "System audio lip sync",
					"description": "Capture audio from other players. The same input drives Beat Sync and Live2D mouth movement.",
					"signal": "Input signal",
					"mouth-open": "Mouth open",
					"input-volume-threshold": "Input volume threshold",
					"random-close-delay": "Random close delay",
					"random-close-probability": "Random close probability",
					"actions": {
						"start": "Start input",
						"stop": "Stop input"
					}
				},
				"panels": {
					"direct-control": "Direct control",
					"preview": "Model preview",
					"timeline": "Timeline",
					"inference": "Model inference"
				},
				"preview": {
					"groups": {
						"expression": "Expression",
						"offset": "Position offset"
					},
					"values": {
						"squint": "Squint",
						"mouth-form": "Form",
						"mouth-open": "Open"
					}
				},
				"joystick-label": "Live2D motion joystick",
				"wave": { "toggle": "Boat mode" },
				"instructions": "Drag the joystick, or use the arrow keys for X/Y. R adds a slight squint. F adds a stronger squint. C closes the eyes. W/S changes the mouth shape. Space opens the mouth. A/D moves the body on X. Q/E tilts the head. Released keys return smoothly to center.",
				"parameter-note": "The joystick controls X/Y. R maps to 1/3 squint. F maps to 2/3 squint. C maps to fully closed eyes. W/S maps to mouth form ±1. Space maps to mouth open 1. A/D maps to body X ±10°. Q/E maps to head Z ±30°.",
				"input": {
					"keyboard": "Keyboard",
					"controller": "Controller"
				},
				"input-actions": {
					"move-body-head": "Move body and head",
					"tilt-head": "Tilt head",
					"blink": "Blink",
					"open-mouth": "Open mouth",
					"mouth-shape": "Change mouth shape"
				},
				"eye-view": {
					"title": "Latched eye view",
					"description": "Choose a target. The eyes counter head movement to keep looking at it.",
					"pad-label": "Latched eye view target",
					"actions": {
						"enable": "Enable fixation",
						"disable": "Disable fixation",
						"center": "Center target"
					},
					"counter": {
						"label": "Head counter strength",
						"description": "How strongly the eyes offset head X/Y movement."
					},
					"values": {
						"target": "Target",
						"output": "Eye output"
					}
				},
				"editor": {
					"title": "Motion editor",
					"instructions": "The gray curve is the source. Add motion overlays or view-target keyframes. Select a track, then drag its points.",
					"play": "Play timeline",
					"pause": "Pause timeline",
					"undo": "Undo",
					"redo": "Redo",
					"crop-to-view": "Crop to view",
					"reset-view": "Reset view",
					"export-project": "Export project",
					"import-project": "Import project",
					"import-error": "This file is not a valid AIRI Live2D motion project.",
					"playback": {
						"label": "Timeline playback controls",
						"start": "Go to start",
						"step-backward": "Step backward",
						"step-forward": "Step forward",
						"end": "Go to end",
						"timecode": "Current and total timecode"
					},
					"input-actions": {
						"play": "Play",
						"stop": "Stop",
						"start": "Go to start",
						"end": "Go to end",
						"step-backward": "Step backward",
						"step-forward": "Step forward",
						"restart-recording": "Record again",
						"clear-timeline": "Clear timeline",
						"previous-track": "Select previous track",
						"next-track": "Select next track"
					},
					"timeline-label": "Motion timeline",
					"timeline-help": "Drag the ruler to scrub. Use the wheel to zoom. Hold Shift and drag to pan. Double-click a selected curve to add a point. Each view-target key holds until the next key.",
					"overlay-count": "{count} overlays",
					"controls": {
						"add": "Add",
						"replace": "Replace",
						"create-keyframes": "Create keyframes",
						"weight": "Weight",
						"remove": "Remove"
					},
					"tracks": {
						"viewTargetX": "View target X",
						"viewTargetY": "View target Y",
						"eyeX": "Eye X",
						"eyeY": "Eye Y",
						"eyeOpen": "Eye open",
						"headX": "Head X",
						"headY": "Head Y",
						"headZ": "Head Z",
						"bodyX": "Body X",
						"bodyY": "Body Y",
						"bodyZ": "Body Z",
						"mouthForm": "Mouth shape",
						"mouthOpen": "Mouth open"
					}
				},
				"var": {
					"title": "VAR idle-motion generator",
					"description": "Fits recorded motion, then generates a new idle sequence.",
					"actions": {
						"fit": "Fit current motion",
						"refit": "Refit current motion",
						"generate": "Generate motion",
						"stop": "Stop generation",
						"new-seed": "New seed"
					},
					"order": {
						"label": "VAR order",
						"description": "Past frames used for each prediction."
					},
					"residual": {
						"label": "Residual strength",
						"description": "Generated variation. Zero is deterministic."
					},
					"diagnostics": {
						"source": "Source",
						"model": "Model",
						"fit": "Fit",
						"run": "Generated run"
					},
					"status": {
						"no-source": "Import or record a motion first",
						"source-ready": "{count} samples · {duration}s",
						"fit-failed": "The VAR fit failed."
					},
					"values": {
						"frames": "{count} frames",
						"model": "{channels} channels · {features} terms",
						"fit": "{frames} frames · RMSE {error} · {duration}ms",
						"run": "seed {seed} · {duration}"
					}
				},
				"ar-hmm": {
					"title": "AR-HMM idle-motion generator",
					"description": "Learns motion states and transitions for varied idle motion.",
					"actions": {
						"fit": "Fit motion",
						"refit": "Refit",
						"generate": "Generate",
						"stop": "Stop",
						"new-seed": "New seed"
					},
					"states": {
						"label": "Hidden states",
						"description": "Motion patterns the model can learn."
					},
					"order": {
						"label": "AR order",
						"description": "Past frames used within each state."
					},
					"residual": {
						"label": "Innovation strength",
						"description": "Variation within each state."
					},
					"diagnostics": {
						"source": "Source",
						"model": "Model",
						"fit": "Fit",
						"states": "State occupancy",
						"run": "Generated run"
					},
					"status": {
						"no-source": "Import or record a motion first",
						"source-ready": "{count} samples · {duration}s",
						"fit-failed": "The AR-HMM fit failed."
					},
					"values": {
						"count": "{count} states",
						"frames": "{count} frames",
						"model": "{states} states · {channels} channels · {features} terms",
						"fit": "log p/frame {likelihood} · {duration}ms",
						"states": "{occupancy} · dwell {dwell}s",
						"run": "state {state} · seed {seed} · {duration}"
					}
				},
				"output-filter": {
					"title": "Generator output filter",
					"description": "Smooths generator output and holds small changes before the spring receives each pose.",
					"actions": {
						"enable": "Enable filter",
						"disable": "Disable filter",
						"reset": "Reset state"
					},
					"smoothing": {
						"label": "EMA smoothing",
						"description": "Blends each accepted target with the previous output. Higher values remove more jitter but add more delay."
					},
					"cutoff": {
						"label": "Change cutoff",
						"description": "Holds a channel until its cumulative normalized change reaches this value."
					},
					"diagnostics": {
						"status": "Status",
						"input-change": "Raw change MAE",
						"output-change": "Filtered change MAE",
						"cutoff-tracks": "Held channels"
					},
					"status": {
						"waiting": "Waiting for a generator",
						"filtering": "Filtering generator output",
						"bypassed": "Passing raw generator output"
					}
				},
				"breath": {
					"title": "Manual breath",
					"description": "Controls ParamBreath with adjustable inhale, exhale, and dwell timing, without adding breath data to recordings.",
					"actions": {
						"enable": "Enable breath",
						"disable": "Disable breath",
						"reset": "Reset cycle"
					},
					"cycle": {
						"label": "Breath duration",
						"description": "Sets the time for one inhale and exhale, before the exhaled dwell."
					},
					"inhale": {
						"label": "Inhale share",
						"description": "Sets the part of the breath duration used to inhale. The remaining time is the exhale."
					},
					"dwell": {
						"label": "Exhaled dwell",
						"description": "Holds ParamBreath at the minimum before the next inhale."
					},
					"minimum": {
						"label": "Minimum",
						"description": "Sets the lowest value written to ParamBreath."
					},
					"maximum": {
						"label": "Maximum",
						"description": "Sets the highest value written to ParamBreath."
					},
					"diagnostics": {
						"stage": "Stage",
						"phase": "Cycle progress",
						"output": "ParamBreath output"
					},
					"stage": {
						"inhale": "Inhale",
						"exhale": "Exhale",
						"dwell": "Exhaled dwell"
					}
				},
				"spring": {
					"follow": {
						"label": "Follow",
						"description": "How quickly motion follows the joystick."
					},
					"inertia": {
						"label": "Inertia",
						"description": "How much momentum the motion keeps."
					}
				},
				"groups": {
					"eyes": "Eyes",
					"head": "Head",
					"body": "Body"
				},
				"recording": {
					"actions": {
						"record": "Record",
						"stop-recording": "Stop recording",
						"play": "Play",
						"stop-playback": "Stop playback",
						"export": "Export",
						"import": "Import"
					},
					"status": {
						"empty": "No motion recording",
						"recording": "Recording motion",
						"playing": "Playing motion",
						"ready": "{count} samples · {duration}"
					},
					"import-error": "This file is not a valid AIRI Live2D motion recording."
				}
			},
			"performance-visualizer": {
				"title": "Performance Visualizer",
				"description": "Inspect live performance metrics and runtime diagnostics",
				"resource-events": {
					"title": "Recent resource events",
					"description": "Newest received event first. Time is milliseconds since the source renderer started.",
					"empty": "No resource events recorded. Load or switch a VRM model while tracing is enabled.",
					"columns": {
						"time": "Time (ms)",
						"phase": "Phase",
						"reason": "Reason",
						"textures": "Textures",
						"geometries": "Geometries",
						"meshes": "Meshes",
						"materials": "Materials"
					}
				},
				"controls": {
					"enable-all": {
						"label": "Enable all available metrics",
						"description": "Enable each metric that this browser supports."
					},
					"start-recording": "Start recording",
					"stop-recording": "Stop recording ({seconds}s)",
					"export-last-recording": "Export last recording"
				},
				"metrics": {
					"fps": {
						"label": "FPS",
						"description": "Animation frame rate during the last 10 seconds. Each sample is 1000 divided by the frame interval in milliseconds."
					},
					"frame-duration": {
						"label": "Frame time (ms)",
						"description": "Time between animation frames during the last 10 seconds."
					},
					"long-task": {
						"label": "Long tasks",
						"description": "Main-thread tasks that take at least 50 ms.",
						"unsupported": "This browser does not expose long-task timing."
					},
					"memory": {
						"label": "JS heap (MB)",
						"description": "JavaScript heap usage from Chromium's performance.memory API.",
						"unsupported": "This browser does not expose JavaScript heap usage."
					}
				},
				"recording": {
					"title": "Last recording",
					"duration": "Duration {duration} ms",
					"limit": "Recording stops after 60 seconds."
				},
				"history": {
					"title": "FPS history",
					"latest": "Latest",
					"minimum": "Min",
					"maximum": "Max",
					"seconds-ago": "-{seconds} s",
					"end": "0 s",
					"empty": "No FPS samples. Enable FPS to collect samples."
				},
				"overlay": {
					"title": "Performance",
					"move": "Move performance overlay",
					"reset-position": "Reset overlay position",
					"record": "Record",
					"stop": "Stop",
					"export": "Export last recording",
					"average": "avg"
				}
			},
			"markdown-stress": {
				"title": "Markdown Stress",
				"description": "Stress markdown parsing and rendering with heavy chat payloads"
			},
			"io-tracer": {
				"title": "IO Tracer",
				"recording": {
					"title": "Record IO traces automatically",
					"description": "Save ended IO spans as JSON Lines in the app data folder so coding agents can analyze them. Files older than seven days are removed."
				}
			},
			"widgets-calling": { "title": "Widget Calling" }
		}
	},
	"screen-capture": { "permissions-prompt": {
		"title": "Screen Capture",
		"description": "To capture screens or windows, screen and system audio recording permissions are required.",
		"open-preferences": "Open System Preferences",
		"dismiss": "Dismiss",
		"instructions": {
			"step-1": "Open \"System Preferences\", select \"Privacy & Security\" from the sidebar.",
			"step-2": "In the \"Screen & System Audio Recording\" and \"System Audio Recording Only\" sections, turn on the switches for AIRI.",
			"step-2-note": "If AIRI is not listed, please add it manually by clicking the \"+\" button and selecting AIRI from the Applications folder."
		}
	} }
};
//#endregion
export { data as default };
